
import { Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { getAllAlternateUrls, getCanonicalUrl, getSocialMediaMetaData } from '~/helpers/metadata';
import MagazineBase from '~/mixins/MagazineBase';
import LoginBase from '~/mixins/LoginBase';
import ContentNavigationB2B from '~/components/website/ContentNavigationB2B.vue';
import { IAPIWebinarTeaser } from '@hokify/common';

const contentStore = namespace('b2b-content');
const magazineStore = namespace('magazine');

@Component({
	name: 'HRTippsPage',
	components: {
		ContentNavigationB2B,
		ContactFormSection: () => import('~/components/website/sections/ContactFormSection.vue')
	},
	layout: 'content-company',
	head() {
		const path = `${this.$store.state.host}/business/hr-tipps`;

		const canonical = getCanonicalUrl(path);
		const alternates = getAllAlternateUrls(path);
		const result: any = {
			title: 'Tipps für Arbeitgeber - Erfolgreiches Recruiting - hokify',
			link: [canonical, ...alternates],
			meta: [
				{ hid: 'robots', name: 'robots', content: 'index, follow' },
				{
					hid: 'description',
					name: 'description',
					content:
						'Tauchen Sie ein in die Welt der Personalsuche. Erfahren Sie von den neuesten Trends zu den Themen Mobile Recruiting, Active Sourcing und modernster Bewerber Kommunikation.'
				}
			]
		};

		result.meta.push(
			...getSocialMediaMetaData(
				result,
				this.$store.state.topLevelDomain,
				undefined,
				undefined,
				this.$route.query
			)
		);
		return result;
	},
	async asyncData({ store }) {
		await Promise.all([
			store.dispatch('magazine/loadArticles', {
				articleOverviewType: 'business',
				includeInterlinking: false
			}),
			store.dispatch('magazine/loadPressLinks', { limit: 3 }),
			store.dispatch('b2b-content/loadPodcasts', { limit: 3 }),
			store.dispatch('b2b-content/loadUpcomingWebinars', { limit: 3 })
		]);
		if (
			store.state['b2b-content'].upcomingWebinarTeaser &&
			store.state['b2b-content'].upcomingWebinarTeaser.length < 3
		) {
			await store.dispatch('b2b-content/loadPastWebinars', {
				limit: 3 - store.state['b2b-content'].upcomingWebinarTeaser.length
			});
		}
	}
})
export default class HRTippsPage extends Mixins(MagazineBase, LoginBase()) {
	@magazineStore.State('pressLinks') pressLinks;

	@contentStore.State('podcastTeaser') podcasts;

	@contentStore.Action('loadPodcasts') loadPodcasts;

	@contentStore.State('upcomingWebinarTeaser') upcomingWebinarTeaser;

	@contentStore.Action('loadUpcomingWebinars') loadUpcomingWebinars;

	@contentStore.State('pastWebinarTeaser') pastWebinarTeaser;

	@contentStore.Action('loadPastWebinars') loadPastWebinars;

	mode = 'contact';

	arrangeWebinar() {
		this.$trackWebsiteEvent('arrange_hubspot_meeting', { pageElement: 'contact_us' });
		window.open(
			`https://hy.hokify.${this.$store.state.topLevelDomain}/meeting-vereinbaren`,
			'_blank'
		);
	}

	get getWebinarList(): IAPIWebinarTeaser[] {
		return this.upcomingWebinarTeaser.concat(this.pastWebinarTeaser);
	}
}
